// extracted by mini-css-extract-plugin
export default {"container":"InputFileHint_container__nAXZQ","icon":"InputFileHint_icon__gDswy","caption":"InputFileHint_caption__111il"};